export default function ManifestoSection() {
  return (
    <section className="relative bg-black py-32 px-6 overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/a005669357a7b43d35fea69211a2e862.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p
          className="fade-in-up text-[#4D1815] text-xs tracking-widest mb-12 uppercase"
          style={{ letterSpacing: '0.5em', fontFamily: "'Cormorant Garamond', serif" }}
        >
          — THE MANIFESTO —
        </p>

        <blockquote
          className="fade-in-up text-[#EADDCC] font-light leading-relaxed mb-12"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(22px, 3.5vw, 42px)',
            lineHeight: 1.6,
            letterSpacing: '0.02em',
          }}
        >
          "Lipstick is not cosmetic.
          <br />
          <em className="italic text-[#EADDCC]/70">It is the mark of desire.</em>
          <br />
          The trace of instinct.
          <br />
          The confession of the beast."
        </blockquote>

        <div className="fade-in-up w-16 h-px bg-[#4D1815] mx-auto" />
      </div>
    </section>
  );
}
